import React, { useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";

type MonthPickerProps = {
  handleInput: (s: string) => void;
  disabled: boolean;
};

export const MonthPicker: React.FC<MonthPickerProps> = ({
  handleInput,
  disabled,
}) => {
  return (
    <div className="mt-3">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          views={["month", "year"]}
          className="answer-box w-full overflow-y-hidden p-5 text-lg lg:text-xl xl:text-2xl"
          onChange={(val) => {
            if (val !== null) {
              const date = val as Dayjs;
              handleInput(date.format("MMMM YYYY"));
            }
          }}
          disabled={disabled}
          slotProps={{
            textField: {
              sx: {
                "& .MuiInputBase-input": {
                  fontFamily: "Source Code Pro, sans-serif", // Apply the custom font
                  padding: "20px",
                  borderRadius: ".75rem",
                  resize: "none",
                  color: "white",
                  fontSize: "1.5rem",
                },
                "& .MuiFormLabel-root": {
                  fontFamily: "Source Code Pro, sans-serif", // Apply to the label
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};
